import { InjectionToken } from "@angular/core";
import { Observable } from "rxjs";
import {
  ResendConfirmationCodeRequest,
  SupportLinksResponse,
  ModifyStaticPasswordRequest,
  LoginConfirmRequest,
  LoginRequest,
  LoginResponse,
  StaticPasswordStatusResponse,
  ActivateStaticPasswordRequest
} from "../../../../../api/model/models";

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_RECEIVE = "LOGIN_RECEIVE";
export const CONFIRM_LOGIN_REQUEST = "CONFIRM_LOGIN_REQUEST";
export const CONFIRM_LOGIN_RECEIVE = "CONFIRM_LOGIN_RECEIVE";
export const RESEND_CONFIRMIATION_CODE_REQUEST = "RESEND_CONFIRMIATION_CODE_REQUEST";
export const RESEND_CONFIRMIATION_CODE_RECEIVE = "RESEND_CONFIRMIATION_CODE_RECEIVE";
export const MODIFY_STATIC_PASSWORD_REQUEST = "MODIFY_STATIC_PASSWORD_REQUEST";
export const MODIFY_STATIC_PASSWORD_RECEIVE = "MODIFY_STATIC_PASSWORD_RECEIVE";
export const GET_STATUS_REQUEST = "GET_STATUS_REQUEST";
export const GET_STATUS_RECEIVE = "GET_STATUS_RECEIVE";
export const ACTIVATE_REQUEST = "ACTIVATE_REQUEST";
export const ACTIVATE_RECEIVE = "ACTIVATE_RECEIVE";
export const GET_RESOURCES_REQUEST = "GET_RESOURCES_REQUEST";
export const GET_RESOURCES_RECEIVE = "GET_RESOURCES_RECEIVE";
export const GET_SUPPORTLINKS_REQUEST = "GET_SUPPORTLINKS_REQUEST";
export const GET_SUPPORTLINKS_RECEIVE = "GET_SUPPORTLINKS_RECEIVE";
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_RECEIVE = "LOGOUT_RECEIVE";

export const CHANGE_STATE = "CHANGE_STATE";
export const RESET_DEFAULT_STATE = "RESET_DEFAULT_STATE";

export const DefaultActionFactoryToken: InjectionToken<DefaultActionFactory> = new InjectionToken<DefaultActionFactory>("default.action.factory");

export interface DefaultActionFactory {
  login (req: LoginRequest): Observable<LoginResponse>;
  confirmLogin (req: LoginConfirmRequest): Observable<Object>;
  resendConfirmationCode (req: ResendConfirmationCodeRequest): Observable<Object>;
  modifyStaticPassword (req: ModifyStaticPasswordRequest): Observable<Object>;
  activateCard(req: ActivateStaticPasswordRequest): Observable<Object>;
  getStatus (): Observable<StaticPasswordStatusResponse>;
  getResources (): Observable<any>;
  getSupportLinks (): Observable<SupportLinksResponse>;
  logout (): Observable<Object>;

  changeState (req: any): Observable<any>;
  resetState (): Observable<any>;
}
